import { initPublicHeader } from './header';

function openMap(lat, lng, type) {
    let url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    switch (type){ // 'waze','google','amap', 'baidu'
        case "waze":
            url = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
            break;
        case "google":
            url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
            break;
        case "amap":
            url = `https://uri.amap.com/marker?position=${lng},${lat}`;
            break;
        case "baidu":
            url = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=hairology&output=html`;
            break;
    }
    window.open(url, '_blank');
}

function updateMap(location) {
    const map = document.getElementById('map');

    if (!map) {
        return;
    }

    const iframe = document.createElement('iframe');
    iframe.id = 'map-frame';
    iframe.title = `${location.name || 'Hairology'} Map`;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('marginheight', '0');
    iframe.setAttribute('marginwidth', '0');
    iframe.src = `https://maps.google.com/maps?width=600&height=400&hl=en&q=${location.lat},${location.lng}&t=&z=16&ie=UTF8&iwloc=B&output=embed`;

    map.replaceChildren(iframe);
}

function initStoreLocator() {
    const countrySelect = document.getElementById('country-select');
    const regionSelect = document.getElementById('region-select');
    const postalCodeSearch = document.getElementById('postal-code-search');
    const searchBtn = document.getElementById('search-btn');
    const storesList = document.getElementById('stores-list');

    if (!storesList) {
        return;
    }

    const storeItems = storesList.querySelectorAll('.store-item');

    function updateMapToFirstVisibleStore() {
        const visibleStores = Array.from(storeItems).filter(store => store.style.display !== 'none');

        if (!visibleStores.length) {
            return;
        }

        const firstStore = visibleStores[0];
        const { lat, lng, name } = firstStore.dataset;

        if (lat && lng) {
            updateMap({ lat, lng, name });
        }
    }

    function filterStores() {
        const selectedCountry = countrySelect?.value;
        const selectedRegion = regionSelect?.value;
        const searchPostal = postalCodeSearch?.value.trim().toLowerCase();

        storeItems.forEach(store => {
            const storeCountry = store.dataset.country;
            const storeRegion = store.dataset.region;
            const storePostal = store.dataset.postal;
            let showStore = true;

            if (selectedCountry && storeCountry !== selectedCountry) {
                showStore = false;
            }

            if (selectedRegion && selectedRegion !== 'all' && storeRegion !== selectedRegion) {
                showStore = false;
            }

            if (searchPostal && !storePostal.includes(searchPostal)) {
                showStore = false;
            }

            store.style.display = showStore ? 'block' : 'none';
        });

        updateMapToFirstVisibleStore();
    }

    countrySelect?.addEventListener('change', filterStores);
    regionSelect?.addEventListener('change', filterStores);
    searchBtn?.addEventListener('click', filterStores);

    postalCodeSearch?.addEventListener('keypress', function (event) {
        if (event.key === 'Enter') {
            filterStores();
        }
    });

    storeItems.forEach(store => {
        store.addEventListener('click', function (event) {
            if (event.target.closest('.store-actions')) {
                return;
            }

            const { lat, lng, name } = this.dataset;

            if (lat && lng) {
                updateMap({ lat, lng, name });
            }
        });
    });

    document.querySelectorAll('.open-map').forEach(btn => {
        btn.addEventListener('click', function (event) {
            event.stopPropagation();

            const { lat, lng, type } = this.dataset;
            openMap(lat, lng, type);
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initPublicHeader();
    initStoreLocator();
});
